function removeSpaces(obj: any) {
    for (var key in obj) {
        if (typeof obj[key] === 'string') {
            obj[key] = obj[key].replace(/ /g, ''); // 将字符串中的空格全部替换为空
            obj[key] = obj[key].replace('\t', ''); // 将字符串中的空格全部替换为空
        } else if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
            removeSpaces(obj[key]); // 递归调用函数处理子对象
        }
    }
}

interface Options<T> {
    pageSize?: number;
    showSizeChanger?: boolean;
    onPageChange?: (page: PaginationAntD) => void;
    data?: Omit<T, 'current | pageSize'>;
}

export default function useTable<T>(
    callback: (params: any) => Promise<any>,
    {pageSize = 9, showSizeChanger, data, onPageChange}: Options<T>,
) {
    // 显示分页信息
    function showTotal(total: number, range: [number, number]) {
        return `第 ${range[0]}-${range[1]} 条/总共 ${total} 条`;
    }

    const tableInit = () => ({
        request: getPageFun,
        sticky: {
            getContainer: () => {
                return document.getElementById('ROOT_MAIN') as HTMLElement;
            },
        },
        pagination: {
            showSizeChanger,
            pageSize,
            showTotal,
        },
    });

    async function getPageFun(params: any) {
        removeSpaces(params);
        const res = await callback({
            ...params,
            ...data,
        });
        onPageChange?.({
            current: params.current,
            pageSize: params.pageSize,
        } as PaginationAntD);
        return {
            data: res.data || [],
            total: res.total || 0,
        };
    }

    return {tableInit};
}
